export const enum LoadMode {
  AMPS = 'amps',
  WATTS = 'watts',
  KVA = 'kva',
}

export interface LoadModeOption {
  label: string;
  value: LoadMode;
}

export class LoadModeHelper {
  private static readonly loadModeLabels: Record<LoadMode, string> = {
    [LoadMode.WATTS]: 'Power (kW)',
    [LoadMode.KVA]: 'Power (kVA)',
    [LoadMode.AMPS]: 'Current (A)',
  };

  private static getConstantList(): LoadMode[] {
    return [LoadMode.WATTS, LoadMode.KVA, LoadMode.AMPS];
  }

  static getOptions(): ReadonlyArray<LoadModeOption> {
    return this.getConstantList().map((mode) => ({
      label: this.loadModeLabels[mode],
      value: mode,
    }));
  }

  static loadModeShortLabel(loadMode: LoadMode): string {
    return this.loadModeLabels[loadMode];
  }

  static getUnit(mode: LoadMode | null | undefined): string {
    switch (mode) {
      case LoadMode.WATTS:
        return 'kW';
      case LoadMode.AMPS:
        return 'A';
      default:
        return 'kVA';
    }
  }
}
